module.exports = __webpack_public_path__ + "static/media/trimex_yoreda.3937e3ec.png";